import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Log, OidcClient } from 'oidc-client';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import config from '../../core/config';

const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
  },
  loginButton: {
    alignItems: 'center',
    background: '#1e1f20',
    borderRadius: '4px',
    color: '#ffffff',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '16px',
    justifyContent: 'center',
    lineHeight: '24px',
    padding: '12px 0',
    textAlign: 'center',
    textDecoration: 'none',
    width: '100%',
  },
});

class Login extends Component {
  async login() {
    Log.logger = console;
    Log.level = Log.INFO;

    const settings = {
      authority: `${config.sso.url}/api/oidc`,
      client_id: config.sso.clientId,
      loadUserInfo: false,
      redirect_uri: config.sso.redirectUri,
      silent_redirect_uri: config.sso.redirectUri,
      response_type: 'code',
      response_mode: 'query',
      scope: 'openid email profile offline_access',
      prompt: 'consent',
      post_logout_redirect_uri: config.base_href,
    };

    const oidcClient = new OidcClient(settings);
    const signinRequest = await oidcClient.createSigninRequest();
    window.location.href = signinRequest.url;
  }

  render() {
    const { classes } = this.props;

    return (
      <main className={classes.main}>
        <Paper className={classes.paper}>
          <button className={classes.loginButton} onClick={this.login}>Sign Into My Member Account</button>
        </Paper>
      </main>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);
